// Approximate a geofence circle as a GeoJSON polygon (no turf dependency).

const EARTH_RADIUS_METERS = 6_378_137;

/** Closed ring of [lng, lat] pairs around a center point. */
export function circlePolygonRing(
  lng: number,
  lat: number,
  radiusMeters: number,
  steps: number = 64,
): [number, number][] {
  if (!Number.isFinite(radiusMeters) || radiusMeters <= 0) {
    return [];
  }
  const safeSteps = Math.max(8, Math.min(steps, 128));
  const latRad = (lat * Math.PI) / 180;
  const lngRad = (lng * Math.PI) / 180;
  const angularDistance = radiusMeters / EARTH_RADIUS_METERS;
  const ring: [number, number][] = [];

  for (let i = 0; i <= safeSteps; i += 1) {
    const bearing = (i / safeSteps) * 2 * Math.PI;
    const lat2 = Math.asin(
      Math.sin(latRad) * Math.cos(angularDistance) +
        Math.cos(latRad) * Math.sin(angularDistance) * Math.cos(bearing),
    );
    const lng2 =
      lngRad +
      Math.atan2(
        Math.sin(bearing) * Math.sin(angularDistance) * Math.cos(latRad),
        Math.cos(angularDistance) - Math.sin(latRad) * Math.sin(lat2),
      );
    ring.push([(lng2 * 180) / Math.PI, (lat2 * 180) / Math.PI]);
  }

  return ring;
}
